<div class="section-loader body-bg" *ngIf="loading">
  <div class="loader-inner ball-beat">
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>

<div class="mContent__header bg-primary py-3 px-5"
  [ngClass]="{'pb-4': !schools?.length && reportForm.get('district').value}">
  <h1 class="text-white mb-1">Reports - Schools</h1>
  <form [formGroup]="reportForm">
    <div class="mControls">
      <div class="input-group">
        <mat-form-field appearance="outline" class="input-white no-error">
          <mat-label>School District</mat-label>
          <mat-select
            formControlName="district"
            (selectionChange)="districtSelected($event)"
          >
            <mat-option
              *ngFor="let district of allDistricts"
              [value]="district.id"
            >
              {{ district.district_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="input-group" style="position: relative;">
        <mat-form-field appearance="outline" class="input-white no-error">
          <mat-label>School</mat-label>
          <mat-select
            formControlName="school"
            (selectionChange)="schoolSelected()"
          >
            <mat-option *ngFor="let school of schools" [value]="school.id">
              {{ school.school_name }}
              {{ school.uuid ? "(" + school.uuid + ")" : "" }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div
          class="text-danger w-100 dropdown_custommsg"
          *ngIf="!schools?.length && reportForm.get('district').value"
        >
          No schools available in this district
        </div>
      </div>
      <div class="input-group">
        <mat-form-field appearance="outline" class="input-white no-error">
          <mat-label>School Year</mat-label>
          <mat-select
            formControlName="school_year"
            (selectionChange)="reportLoaded = false"
          >
            <mat-option *ngFor="let year of schoolYears" [value]="year">
              {{ year }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="input-group mr-auto">
        <button
          (click)="renderReport(reportForm.getRawValue())"
          mat-raised-button
          [disabled]="!reportForm.valid"
        >
          <mat-icon>play_arrow</mat-icon> Run Report
        </button>
      </div>
      <div class="mControls__right">
        <div class="input-group">
          <button
            mat-raised-button
            [disabled]="!reportLoaded"
            (click)="exportAllReports()"
          >
            <mat-icon>publish</mat-icon> Export Report
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<div
  class="scroll flex-fill overflow-auto py-3 px-5"
  *ngIf="filtersSelected && reportLoaded"
>
  <div class="container p-0 h-100">
    <div class="d-flex flex-column h-100 tab-group-area">
      <mat-tab-group (selectedIndexChange)="setListForTab($event)">
        <mat-tab label="1st Grade">
          <ng-container *ngTemplateOutlet="tabContent"></ng-container>
        </mat-tab>
        <mat-tab label="2nd Grade">
          <ng-container *ngTemplateOutlet="tabContent"></ng-container>
        </mat-tab>
        <mat-tab label="3rd Grade">
          <ng-container *ngTemplateOutlet="tabContent"></ng-container>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
<div class="flex-fill d-flex" *ngIf="!filtersSelected">
  <div class="m-auto">
    <img src="assets/images/no-result.png" alt="" />
    <h2 class="text-center">Select filters and run a report</h2>
  </div>
</div>
<div class="flex-fill d-flex" *ngIf="filtersSelected && !reportLoaded">
  <div class="m-auto">
    <img src="assets/images/no-result.png" alt="" />
    <h2 class="text-center">Click on "Run Report" to render the new report</h2>
  </div>
</div>

<ng-template #tabContent>
  <div class="overflow-auto">
    <div class="row mx-0 mt-4" id="allGraphs">
      <div class="col-lg-6 px-2 mb-3">
        <div class="card h-100">
          <div class="card-body">
            <div *ngIf="selectedReport">
              <button
                mat-raised-button
                color="primary"
                class="on-hover-showbtn"
                (click)="exportIndividualReport('DRA')"
              >
                EXPORT
              </button>
              <div id="draChart">
                <app-basic-column-chart
                  [title]="titleDRA"
                  [tickMax]="currentGrade === 'fifth_grade' ? 100 : 50"
                  [stepSize]="10"
                  [legendData]="['H.U.G. Students', 'Control Group']"
                  [categories]="['Fall DRA', 'Winter DRA', 'Spring DRA']"
                  [chartData]="graphData?.dra?.data"
                  [extraData]="graphData?.dra?.extraData"
                >
                </app-basic-column-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 px-2 mb-3">
        <div class="card h-100">
          <div class="card-body">
            <div *ngIf="selectedReport">
              <button
                mat-raised-button
                color="primary"
                class="on-hover-showbtn"
                (click)="exportIndividualReport('Acumen')"
              >
                EXPORT
              </button>
              <div id="acumenChart">
                <app-double-donut-chart
                  [title]="titleAcumen"
                  [subTitle]="subtitleAcumen"
                  [chartData]="acumenData"
                  [gain]="averageGain"
                ></app-double-donut-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 px-2 mb-3">
        <div class="card h-100">
          <div class="card-body">
            <div *ngIf="selectedReport">
              <button
                mat-raised-button
                color="primary"
                class="on-hover-showbtn"
                (click)="exportIndividualReport('RIT')"
              >
                EXPORT
              </button>
              <div id="ritChart">
                <app-basic-column-chart
                  [title]="titleRIT"
                  [tickMax]="300"
                  [stepSize]="50"
                  [legendData]="['H.U.G. Students', 'Control Group']"
                  [categories]="['Fall RIT', 'Winter RIT', 'Spring RIT']"
                  [chartData]="graphData?.rit?.data"
                  [extraData]="graphData?.rit?.extraData"
                ></app-basic-column-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 px-2 mb-3">
        <div class="card h-100">
          <div class="card-body">
            <div *ngIf="selectedReport">
              <button
                mat-raised-button
                color="primary"
                class="on-hover-showbtn"
                (click)="exportIndividualReport('Rank')"
              >
                EXPORT
              </button>
              <div id="rankChart">
                <app-basic-column-chart
                  #rankChart
                  [title]="titleRank"
                  [tickMax]="100"
                  [stepSize]="20"
                  [legendData]="['H.U.G. Students', 'Control Group']"
                  [categories]="[
                    'Fall % Rank',
                    'Winter % Rank',
                    'Spring % Rank'
                  ]"
                  [chartData]="graphData?.rank?.data"
                  [extraData]="graphData?.rank?.extraData"
                ></app-basic-column-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
